import React from 'react';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";


class ProductListSliderItem extends React.PureComponent {
    constructor(props) {
        super(props);
        this.ref = React.createRef();
    }

    componentDidMount() {
        window.__litium.loadBuyButtons(this.ref.current);
    }

    render() {
        const { item } = this.props;
        return (
            <div className="product-listing-carousel-item" dangerouslySetInnerHTML={{ __html: item }} ref={this.ref} />
        )
    }
}

class ProductListSlider extends React.Component {
    constructor(props) {
        super(props);
        this.sliderRef = React.createRef();
    }

    componentDidMount() {
        setTimeout(() => window.__litium.loadBuyButtons(this.sliderRef.current), 0);
    }

    componentDidUpdate() {
        setTimeout(() => window.__litium.loadBuyButtons(this.sliderRef.current), 0);


    }

    render() {
        const { values, header, subheader } = this.props;
        const responsive = (items) => {
            return {
                largeDesktop: {
                    breakpoint: { max: 3000, min: 1260 },
                    items: 4,
                    slidesToSlide: 1,
                },
                desktop: {
                    breakpoint: { max: 1259, min: 1024 },
                    items: 4,
                    slidesToSlide: 1,
                    partialVisibilityGutter: -90
                },
                tablet: {
                    breakpoint: { max: 1023, min: 700 },
                    items: 3,
                    slidesToSlide: 1,
                    partialVisibilityGutter: -80
                },
                mobile: {
                    breakpoint: { max: 699, min: 200 },
                    items: 2,
                    slidesToSlide: 1,
                    partialVisibilityGutter: -100
                },
            };
        }

        const CarouselSettings = {
            swipeable: true,
            draggable: true,
            showDots: values.length > 2 ? true : false,
            responsive: responsive(values.length),
            infinite: false,
            arrows: true,
            partialVisible: false,
            customTransition: "transform 250ms ease-in-out",
            itemClass: "carousel-item-card",
        };

        return (
            <div className="product-listing__slider-wrapper" ref={this.sliderRef}>
                <h2 className="product-listing--header">{header}</h2>
                <div className="product-listing--subheader">{subheader}</div>
                <Carousel {...CarouselSettings}>
                    {values.map((value, index) =>
                        <ProductListSliderItem item={value} key={index} />
                    )}
                </Carousel>
            </div>
        )
    }
}
export default ProductListSlider;

